import Controller from "./asyncList.controller";
import template from "./asyncList.html";

const asyncList = {
  template,
  controller: Controller,
  bindings: {
    field: "=",
    allFields: "=",
    selected: "=",
    extraParamsFields: "<",
  },
};

export default asyncList;



// WEBPACK FOOTER //
// ./src/components/asyncList/asyncList.component.js